module.exports = __webpack_public_path__ + "img/icon_telegram.ffd11e5b.png";